var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiftyOrbit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "40px",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nifty orbit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.1433263,7.52632641 C25.3024155,12.9352288 23.266742,19.113577 18.3152727,22.1796565 C13.3638035,25.245736 6.92572454,24.3145572 3.04593346,19.9711585 L3.04593346,19.9711585 L2.67828702,20.338805 C2.0018609,21.0108263 0.930022665,21.0716006 0.181967662,20.4803489 C0.237927446,20.4362505 0.291323114,20.3889922 0.341893865,20.338805 L0.341893865,20.338805 L5.53122342,15.1568283 L5.64519382,15.042858 C6.33480749,14.4054673 7.39859076,14.4054673 8.08820443,15.042858 L8.08820443,15.042858 L8.18746897,15.1439607 L10.5201857,17.4766774 C10.538568,17.496898 10.5606268,17.5134421 10.5808473,17.5318244 C11.3269716,18.2091642 12.4724686,18.1849465 13.1892988,17.4766774 L13.1892988,17.4766774 Z M5.74639638,1.76058572 C10.2492456,-0.990474761 16.0206497,-0.478326618 19.9686993,3.02265747 L19.9686993,3.02265747 L20.1323019,2.85905481 C20.8143701,2.18122546 21.8974272,2.12576533 22.6451654,2.73037855 C22.5803541,2.78080407 22.5189459,2.83545736 22.4613422,2.89398122 L22.4613422,2.89398122 L13.0863578,12.2689655 C12.3939016,12.918912 11.3155829,12.918912 10.6231267,12.2689655 L10.6231267,12.2689655 L10.5367297,12.1825686 L8.2573218,9.90316067 C8.23526301,9.87926365 8.21871892,9.85169017 8.19666014,9.82963138 C7.45659463,9.09987972 6.26761246,9.09987972 5.52754695,9.82963138 C5.50364994,9.85169017 5.48894408,9.87926365 5.46688529,9.90316067 L5.46688529,9.90316067 L0.37865851,14.9913874 C-0.934678458,9.88069951 1.24354712,4.5116462 5.74639638,1.76058572 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.831286%",
    y1: "19.8370497%",
    x2: "83.831286%",
    y2: "80.3507432%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EE3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019B8E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019B8E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discussions-thread",
    transform: "translate(-276.000000, -887.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(276.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nifty-orbit",
    transform: "translate(0.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    stroke: "#02B1A3",
    x: 2.5,
    y: 1.5,
    width: 36,
    height: 36,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F98D40",
    cx: 38,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F98D40",
    cx: 4,
    cy: 36,
    r: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#01BAAB",
    fillRule: "nonzero",
    opacity: 0.196958699,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    cx: -3.43949045,
    cy: 11.9235669,
    rx: 17.1974522,
    ry: 17.1210191
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "url(#linearGradient-4)",
    opacity: 0.300000012,
    mask: "url(#mask-2)",
    cx: 19.6433121,
    cy: 20.7133758,
    r: 14.2929936
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1194268,29.5031847 C24.4935667,29.5031847 29.660828,24.3359234 29.660828,17.9617834 C29.660828,11.5876435 24.4935667,6.42038217 18.1194268,6.42038217 C11.7452868,6.42038217 1.52866242,16.6866625 1.52866242,23.0608025 C1.52866242,29.4349424 11.7452868,29.5031847 18.1194268,29.5031847 Z",
    id: "Oval-Copy-2",
    fill: "#01BBAC",
    opacity: 0.5,
    mask: "url(#mask-2)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiftyOrbit);
export default __webpack_public_path__ + "static/media/nifty-orbit.e01bf363242247e24d6c98b1e6acfc73.svg";
export { ForwardRef as ReactComponent };